import React, { useEffect } from 'react';
import { TreeView } from '@mui/lab';
import { Checkbox, FormControlLabel } from '@mui/material';
import { AssetTreeView } from '../../../types/app/assetTreeView.types';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useState } from 'react';
import { getDescendantsObject } from '../../../utils/core/functions/assetTreeView.fuctions';

interface Props {
  assetTreeViewData: AssetTreeView;
  onChange: (selectedAssetsIds: AssetTreeView[]) => void;
}

export default function AssetTreeViewContainer({ assetTreeViewData, onChange }: Props) {
  const [selectedAssets, setSelectedAssets] = useState<AssetTreeView[]>([]);
  const [expanded, setExpanded] = useState<string[]>([]);

  useEffect(() => {
    if (!assetTreeViewData) return;
    setSelectedAssets([assetTreeViewData]);
    onChange([assetTreeViewData]);
  }, []);

  useEffect(() => {
    setExpanded([assetTreeViewData.influxMachineName]);
  }, []);

  const handleOnChange = (asset: AssetTreeView, isChecked: boolean) => {
    let _selectedAssets: AssetTreeView[] = [];
    if (selectedAssets.filter((x) => x.id === asset.id).length > 0 && !isChecked)
      _selectedAssets = selectedAssets.filter((item) => item.id !== asset.id);
    else _selectedAssets = [...selectedAssets, asset];

    // Potomci
    const descendants = getDescendantsObject(asset);
    descendants.shift();

    if (isChecked) _selectedAssets = [..._selectedAssets, ...descendants];
    else {
      descendants.forEach((descendants) => {
        _selectedAssets = [..._selectedAssets.filter((itm) => itm.id !== descendants.id)];
      });
    }

    setSelectedAssets(_selectedAssets);
    onChange(_selectedAssets);
  };

  const renderTree = (asset: AssetTreeView) => {
    return (
      <TreeItem
        key={asset.influxMachineName}
        nodeId={asset.influxMachineName.toString()}
        label={
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedAssets.some((item) => item.id === asset.id)}
                onChange={(e) => handleOnChange(asset, e.currentTarget.checked)}
                onClick={(e) => e.stopPropagation()}
              />
            }
            label={asset.name}
            key={asset.influxMachineName}
          />
        }
      >
        {asset.assetDescendants.map((item: AssetTreeView) => renderTree(item))}
      </TreeItem>
    );
  };

  const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}
      onNodeToggle={handleToggle}
    >
      {renderTree(assetTreeViewData)}
    </TreeView>
  );
}
